export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=0ad4f1d2&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/index.vue?vue&type=template&id=0ad4f1d2&scoped=true
// module id = QdDi
// module chunks = 0